// extracted by mini-css-extract-plugin
export default {"body":"house-account-assignment-modal_body__tA1RL","searchRow":"house-account-assignment-modal_searchRow__Y4hT8","error":"house-account-assignment-modal_error__HG+MM"};